// extracted by mini-css-extract-plugin
module.exports = {"ContentBody":"ContentBody_ContentBody__2sAZQ"};